import React from 'react';

export const Plus = ({
  color,
  width = 18,
  height = 18
}: {
  color?: string;
  width?: number;
  height?: number;
}): JSX.Element => {
  const className = 'icon icon--plus';
  color = color || '#0076CC';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M9 1V17M17 9L1 9"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Plus;
